import { explorerStateToQueryPairs, type ExplorerState } from './state'

export function canonicalBillPath(boletin: string): string {
  return `/proyecto/${boletin}`
}

export function canonicalVotePath(boletin: string, voteSlug: string): string {
  return `/proyecto/${boletin}#${voteSlug}`
}

export function extractVoteSlug(rawHash: string): string | null {
  // Mirror Rust: trim_start_matches('#') strips ALL leading '#', then trim whitespace
  const hash = rawHash.replace(/^#+/, '').trim()
  if (hash === '') return null
  return hash
}

export function explorerUrl(state: ExplorerState): string {
  const pairs = explorerStateToQueryPairs(state)
  if (pairs.length === 0) return '/'
  const query = pairs
    .map(([key, value]) => `${encodeQueryComponent(key)}=${encodeQueryComponent(value)}`)
    .join('&')
  return `/?${query}`
}

const encoder = new TextEncoder()

/**
 * Percent-encode a query component using the same byte-wise rules as the Rust
 * `encode_query_component` function. Unreserved chars (A-Z a-z 0-9 - _ . ~)
 * pass through; space becomes %20; everything else is %XX.
 *
 * This is intentionally NOT encodeURIComponent — it differs on ! ' ( ) *
 * and produces the exact same output as the Rust implementation.
 */
function encodeQueryComponent(value: string): string {
  let encoded = ''
  for (const byte of encoder.encode(value)) {
    if (
      (byte >= 0x41 && byte <= 0x5a) || // A-Z
      (byte >= 0x61 && byte <= 0x7a) || // a-z
      (byte >= 0x30 && byte <= 0x39) || // 0-9
      byte === 0x2d || // -
      byte === 0x5f || // _
      byte === 0x2e || // .
      byte === 0x7e    // ~
    ) {
      encoded += String.fromCharCode(byte)
    } else if (byte === 0x20) {
      encoded += '%20'
    } else {
      encoded += `%${byte.toString(16).toUpperCase().padStart(2, '0')}`
    }
  }
  return encoded
}
